import { Api } from '@/api'

export function useApi() {
  const {
    public: { apiBase },
  } = useRuntimeConfig()

  return new Api({ baseUrl: apiBase })
}
